import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../../../../collection'
import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * Executes the get attributes request
 */
export const executeGetAttributes = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    collection: Collection<TTypeParams>,
  ) =>
    collection.plugins.apiExecutionPlugin.canExecute('getAttributes')
      ? feature.actions.getAttributes.relay(forwardTo =>
          collection.feature.selectors.context.asObservable.pipe(
            // We need to get the context, but just the most recent value
            rxjs.take(1),
            rxjs.map(context =>
              forwardTo(
                collection.plugins.apiExecutionPlugin.feature.actions.execute,
                {
                  input: {
                    context,
                    methodName: 'getAttributes',
                  },
                  output: ({ response }) => ({
                    // NOTE: since `execute` can return a variety of
                    // results, we need to tell TypeScript which result we
                    // expect
                    attributes: response as rxjs.ObservedValueOf<
                      ecModels.Api.Method.Result<
                        'getAttributes',
                        typeof collection.api
                      >
                    >,
                  }),
                },
              ),
            ),
          ),
        ).asObservable
      : undefined,
)
